export const PlayerEvent = {
  /** video标准事件，顺序从前到后 */
  LOADSTART: 'loadstart',
  LOADEDMETADATA: 'loadedmetadata',
  LOADED: 'loadeddata',
  PROGRESS: 'progress',
  CANPLAY: 'canplay',
  CANPLAYTHROUGH: 'canplaythrough',
  PLAY: 'play',
  PLAYING: 'playing',
  TIMEUPDATE: 'timeupdate',
  SEEKING: 'seeking',
  SEEKED: 'seeked',
  WAITING: 'waiting',
  STALLED: 'stalled',
  PAUSE: 'pause',
  RATECHANGE: 'ratechange',
  VOLUMECHANGE: 'volumechange',
  ENDED: 'ended',
  ERROR: 'error',

  /** 播放业务逻辑事件 */
  SCHEDULER_COMPLETE: 'schedulercompleted',
  SCHEDULER_SUCCESS: 'schedulersuccess',
  SCHEDULER_FAIL: 'schedulerfail',
  READY: 'ready',
  CHANGEKERNEL: 'changekernel',
  CHANGEKERNELDATA: 'changekerneldata',
  CHANGE_SCHEDULER_DATA: 'changeschedulerdata',
  LOOP_CHANGED: 'loopchange',
  MUTED_CHANGED: 'mutedchange',
  SRC_CHANGED: 'srcchange',
  CURRENT_TIME_CHANGED: 'setcurrenttime',
  PLAYBACKRATE_LIST_CHANGED: 'playbackratelistchange',
  /** 清晰度变化 */
  DEFINITION_CHANGED: 'definitionchange',
  /** 清晰度列表变化 */
  DEFINITION_LIST_CHANGED: 'definitionlistchange',
  /** 重新调度完成 */
  REFRESH_DISPATCH_COMPLETED: 'refreshDispatchCompleted',
  BUFFER_FULL: 'buffer_full',
  CHANGE_LINE: 'changeline',
  // 直播时移事件
  LIVE_TIMESHIFT: 'liveTimeshift',
  // 开启点播字幕
  OPEN_SUBTITLE: 'openSubtitle',
  // 关闭点播字幕
  CLOSE_SUBTITLE: 'closeSubtitle',
  // 点播字幕挂载完成
  VOD_SUBTITLE_MOUNTED: 'vodSubtitleMounted',
  // 切换字幕文件
  SUBTITLE_CHANGED: 'subtitleChanged',
  // 自动播放成功
  AUTOPLAY_SUCCESS: 'autoplaySuccess',
  // 自动播放失败
  AUTOPLAY_FAILED: 'autoplayFailed',
  // 触发播放, 用于日志上报
  // 注意：存在内部调用play()。不能代表用户点击播放！
  TOUCH_PLAY: 'touchPlay',
  // 直播字幕开启事件
  LIVESUBTITLE_OPENED: 'liveSubtitleOpened',
  // 直播字幕关闭事件
  LIVESUBTITLE_CLOSED: 'liveSubtitleClosed',
  // 进入画中画
  ENTER_PICTURE_IN_PICTURE: 'enterPictureInPicture',
  // 退出画中画
  EXIT_PICTURE_IN_PICTURE: 'exitPictureInPicture',
  // Switcher插件触发切线
  SRC_SWITCH: 'src_switch',

  /** 以下，未使用 */
  NO_SRC_FOUND: 'no_src_found',
  TS_NOT_FOUND: 'ts_not_found',
  M3U8_NOT_FOUND: 'm3u8_not_found',
  ATTACH_MEDIA: 'attach_media',
  DETACH_MEDIA: 'detach_media',
  TIMESHIFT_TIMEUPDATE: 'timeshift_timeupdate',
  BUFFER_EMPTY: 'buffer_empty',
};
